import {ListQuestion} from '../../shared/models/list-question';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Question } from "../../shared/models/question";
import { MultipleChoiceQuestion } from "../../shared/models/multiple-choice-question";
import { QuestionSet } from "../../shared/models/question-set";
import { QuestionSetLabel } from "../../shared/models/question-set-label";
import { QuestionType } from 'app/shared/models/question-type';

@Component({
  selector: 'dac-question-set',
  templateUrl: './question-set.component.html'
})
export class QuestionSetComponent implements OnInit, OnChanges {

  @Input() questionSet:QuestionSet;

  public question_class_size:number;
  public last_label_size:number;
	private LABEL_SIZE:number = 6;
	private _isSingleQuestion:boolean = false;

  constructor() { 
		
    // TODO: stephen is the watch taken care with angular2??
		// this._$scope.$watch('questionSet', this.setUpdated.bind(this));

		// I believe the isolated scope prevents the ctrl from being bound so
		// assigning this to the ctrl allows us to work with the controller.
  }

  ngOnInit() {
    this.setupQuestionSet();
  }

	ngOnChanges(changes: SimpleChanges) {
		this.setupQuestionSet();
	}

	setupQuestionSet() {
		this.updateSingleQuestion();
		this.calculateColumnSizes();
	}

	updateSingleQuestion() {
		if (this.questionSet && this.questionSet.questions.length === 1) {
			this._isSingleQuestion = true;
		}
		else {
			this._isSingleQuestion = false;
		}
	}

  calculateColumnSizes() {
		if (!this.questionSet) {
			return;
		}
		if (this.questionSet.labels && this.questionSet.labels.length > 6) {
			// keep a minimum of 2 rows for the question.
			this.question_class_size = Math.max(2, 12 - this.questionSet.labels.length);
			this.last_label_size = 1;
		}
		else {
			this.question_class_size = this.LABEL_SIZE;
			this.last_label_size = Math.min(1, this.LABEL_SIZE - this.questionSet.labels.length);
		}
	}

  public get isSingleQuestion() {
		return this._isSingleQuestion;
	}
	
	setUpdated(newValue, oldValue) {
		// we want the newest question sets to be on top.
		if (!newValue) {
			return;
		}
		if (newValue.questions && newValue.questions.length === 1) {
			this._isSingleQuestion = true;
		}
		else {
			this._isSingleQuestion = false;
		}
	}
	getLabelClasses() {
		let labels = this.questionSet.labels.length;
		if (labels < this.LABEL_SIZE) {
			return "col-md-" + (this.LABEL_SIZE - labels); 
		}
		
		return "d-none";
	}
	selectLabel(qs, label:QuestionSetLabel) {
		// this only works with multiple choice questions... doesn't work for anything else
		// TODO: stephen this feels wrong here in this abstraction and suggests we need
		// to rework the conceptual model of question-set's to fix this.
		qs.questions.forEach(function(question:Question) {
			if (question instanceof MultipleChoiceQuestion) {
				question.answer = label;
			}
		});
	}

	getQuestionLabels(question:ListQuestion) {
		return question.CustomLabels;
	}

	// TODO: stephen instead of all these cases would it be better just to dynamically create the components?
	isMultipleChoice(type:QuestionType) {
		return type == QuestionType.MultipleChoice;
	}
	isTextbox(type:QuestionType) {
		return type == QuestionType.Textbox;
	}

	isChecklist(type:QuestionType) {
		return type == QuestionType.Checklist;
	}
	isSingleChoice(type:QuestionType) {
		return type == QuestionType.SingleChoice;
	}
}



// WEBPACK FOOTER //
// ./src/app/assessments/question-set/question-set.component.ts